import React, { useEffect } from 'react';
// import logo from './assets/logo.svg';
import './App.scss';

import {types} from "./lib/store";
import {useStoreActions, useStoreState} from "easy-peasy";

import Graph from './components/Graph';
import PowerLine from "./components/PowerLine";
import DesignPoint from './components/DesignPoint';
import ServicePoint from './components/ServicePoint';
import AcousticGraph from "./components/AcousticGraph";
import AcousticPoint from "./components/AcousticPoint";
import GeneralFanFlowTitle from "./components/GeneralFanFlowTitle";
import ErpData from "./components/ErpData";
import GeneralSidebar from "./components/GeneralSidebar";
import GeneralData from "./components/GeneralData";
import GeneralMotorData from "./components/GeneralMotorData";
import Simulation, { types as simulationTypes } from "./components/Simulation";
import ReportButton from "./components/ReportButton";
import FocusCurve from "./components/FocusCurve";
import GeneralTitle from "./components/GeneralTitle";
import VariantSelector from "./components/VariantSelector";
import Documentation from "./components/Documentation";

function App({ endpoint, designPoint, fan }) {
  const features = useStoreState(state => state.selection.features);
  const sections = useStoreState(state => state.selection.sections);
  const setDesignPoint = useStoreActions(actions => actions.selection[types.SET_DESIGN_POINT]);
  const updateEndpoint = useStoreActions(actions => actions.selection[types.SET_ENDPOINT]);
  const setSimulationType = useStoreActions(actions => actions.selection[types.CHANGE_SIMULATION_TYPE]);

  useEffect(() => {
    updateEndpoint(endpoint);

    if (designPoint.frequency !== fan.frequency) {
      // Call this before update design point
      setSimulationType({ type: simulationTypes.FREQUENCY, reload: false });
    }

    setDesignPoint(designPoint);
  }, [endpoint, designPoint, updateEndpoint, setDesignPoint, fan, setSimulationType]);

  return (
    <>
      <div className="row">
        <div className={ features.includes("controls") ? "col-xs-12 col-md-8 col-lg-9" : "col-xs-12" }>
          <Graph />
          {features.includes("sound") && <AcousticGraph />}
        </div>
        {features.includes("controls") &&
          <div className="fan-sidebar fan-sidebar-main col-xs-12 col-md-4 col-lg-3">
            <DesignPoint/>
            <VariantSelector/>
            <Simulation/>
            <PowerLine/>
            <FocusCurve/>
            <ServicePoint/>
            {features.includes("sound") && <AcousticPoint/>}
          </div>
        }
      </div>
      {sections.includes("data") && <ErpData />}
      {sections.includes("data") && <GeneralSidebar />}
      {sections.includes("data") && <GeneralTitle />}
      {sections.includes("data") && <GeneralFanFlowTitle />}
      {sections.includes("data") && <GeneralData />}
      {sections.includes("data") && <GeneralMotorData />}
      {sections.includes("docs") && <Documentation />}
      <ReportButton />
    </>
  );
}

export default App;
